import {AxiosRequest, HttpUtils} from '../../../utils/HttpUtils';
import {HttpStatus} from "../../common/enums/HttpStatus";
import {DepartmentDto} from "../dto/DepartmentDto";

export const DepartmentApi = {

    getDepartmentList: async () => {
        try {
            const params = new Map<string, string>();
            const requestUrl = HttpUtils.addQueryString('/v1/account/department/list', params);
            const axiosResponse = await AxiosRequest.get(requestUrl);
            return axiosResponse.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
    },
    
    constructDepartmentTree: (departmentList: Array<DepartmentDto>) => {
        // 构建树
        const departmentMap = new Map<string, DepartmentDto>();
        const rootDepartmentList = new Array<DepartmentDto>();
        for (let department of departmentList) {
            departmentMap.set(department.id, department);
        }

        for (let department of departmentList) {
            if (department.parentId && departmentMap.has(department.parentId)) {
                const parentDepartment = departmentMap.get(department.parentId);
                if (parentDepartment) {
                    // 加了parent的引用，提交的数据转json会异常
                    // department.parent = parentDepartment;
                    if (!parentDepartment.children) {
                        parentDepartment.children = [];
                    }
                    parentDepartment.children.push(department);
                }
            } else {
                rootDepartmentList.push(department);
            }
        }
        return rootDepartmentList;
    },

    getDepartmentDetail: async (id: string) => {
        try {
            const params = new Map<string, string>();
            params.set('id', id);
            const requestUrl = HttpUtils.addQueryString('/v1/account/department/detail', params);
            const axiosResponse = await AxiosRequest.get(requestUrl);
            return axiosResponse.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
    },

    createDepartment: async (body: DepartmentDto) => {
        try {
            const requestUrl = '/v1/account/department/create';
            const axiosResponse = await AxiosRequest.post(requestUrl, body);
            return axiosResponse.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
    },

    updateDepartment: async (body: DepartmentDto) => {
        try {
            const requestUrl = '/v1/account/department/update';
            const axiosResponse = await AxiosRequest.post(requestUrl, body);
            return axiosResponse.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
    },

    deleteDepartment: async (id: string) => {
        try {
            const params = new Map<string, string>();
            params.set('id', id);
            const requestUrl = HttpUtils.addQueryString('/v1/account/department/delete', params);
            const axiosResponse = await AxiosRequest.post(requestUrl);
            return axiosResponse.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
    },
};
